$(function() {
    'use strict';
    var trackingUtils = require('../modules/utils/tracking.utils');

    var hideErrorContainer = function(trackEvent, hideContainer) {
        this.$cachedSelectors.errorContainer.toggleClass('hidden', hideContainer);
        trackingUtils.trackEvent('genesys_chat', trackEvent);
    };

    Odigeo.defineWidget('error_message_manager', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            init: function() {
                this.set('error', null);
            },
        }),
        viewClass: Odigeo.View.extend({
            init: function() {
                this.validErrorsPAY = ['COLLECTION_UNKNOWN', 'Test API error'];
            },
            events: {
                'tap .dialog_close_hint_icon': 'closeWindow',
                'tap .open_chat': 'openChat',
                'tap .try_again': 'tryAgain',
            },

            selectors: {
                'errorContainer': '.errormessage_container',
                'chatSection': '.chat_container',
            },

            closeWindow: function() {
                hideErrorContainer.call(this, 'chat_close_layer', true);
            },

            openChat: function() {
                hideErrorContainer.call(this, 'chat_open', true);
                Odigeo.trigger(this.widget.id + ':openChat', this.model.error);
            },

            tryAgain: function() {
                hideErrorContainer.call(this, 'chat_close_try_again', true);
                Odigeo.trigger(this.widget.id + ':tryAgain');
            },

            showChatSection: function(valid) {
                var error = this.model.get('error');
                if (-1 < _.indexOf(this.validErrorsPAY, error) && valid) {
                    hideErrorContainer.call(this, 'chat_appearances', !valid);
                    this.$cachedSelectors.errorContainer.removeClass('hidden')
                        .find('.chat_container').removeClass('hidden')
                        .find('[data-error="' + error + '"]').removeClass('hidden');
                }
                this.$cachedSelectors.chatSection.toggleClass('hidden', !valid);
            },
        }),

        manageError: function(error) {
            this.model.set('error', error);
            Odigeo.trigger(this.id + ':validateChat');
        },

        showChatSection: function(valid) {
            this.view.showChatSection(valid);
        },
    }));
});
